export const PitchInformationFormId = "pitch-information";

export enum PitchInformationSubFormsId {
  PublisherDeveloperInformation = "publisherDeveloperInformation",
  AboutYourGame = "aboutYourGame",
  AskForXbox = "askForXbox",
  AboutYourself = "aboutYourself",
}

export const PitchInformationSubFormsIdsOrder = [
  PitchInformationSubFormsId.PublisherDeveloperInformation,
  PitchInformationSubFormsId.AboutYourGame,
  PitchInformationSubFormsId.AskForXbox,
  PitchInformationSubFormsId.AboutYourself,
];

export const PitchInformationSubFormsLocalizedStringIds: { [subForm: string]: string } = {
  ["formTitle"]: "pitchInformationTitle",
  ["formSubtitle"]: "pitchInformationSubtitleDescription",
  [PitchInformationSubFormsId.PublisherDeveloperInformation]:
    "pitchInformationPublisherDeveloperInformationTitle",
  [PitchInformationSubFormsId.AboutYourGame]: "pitchInformationAboutYourGameTitle",
  [PitchInformationSubFormsId.AskForXbox]: "pitchInformationAskForXboxTitle",
  [PitchInformationSubFormsId.AboutYourself]: "pitchInformationAboutYourselfTitle",
};
